import { jsx as _jsx } from "react/jsx-runtime";
import { useConfig, useFeaturesEnabled } from "@/contexts/cdpConfig";
import { usePriceComparison } from "@/contexts/classified";
import { useContactContext, usePlatoAvailable } from "@/contexts/contact";
import { useI18n, useIsNewBuildProject } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { TagIcon } from "@gemini/icons";
import { Button } from "@gemini/ui";
import { contactFormTestId } from "../ContactForm/constants";
export const suggestPriceButtonTestId = `${contactFormTestId}-suggest-price-button`;
export const SuggestPriceButton = ({ isModal }) => {
    const { t } = useI18n();
    const isPreviewMode = useConfig().previewMode;
    const { toggleSuggestPriceModal } = useContactContext();
    const priceComparison = usePriceComparison();
    const isPlatoAvailable = usePlatoAvailable();
    const { suggestPrice } = useFeaturesEnabled();
    const variant = "secondary";
    const av_zone = "suggest_a_price";
    const legacyTrackingInfos = "suggest_a_price";
    const isProject = useIsNewBuildProject();
    // Business logic based on AC from https://avivgroup.atlassian.net/browse/TSCN-146
    const isSuggestPriceButtonVisible = suggestPrice &&
        !isPlatoAvailable &&
        (priceComparison === null || priceComparison === void 0 ? void 0 : priceComparison.isSale) &&
        !isModal &&
        !isProject;
    const handlePress = () => {
        if (isPreviewMode)
            return;
        toggleSuggestPriceModal({
            av_zone,
            legacyTrackingInfos,
        });
    };
    if (!isSuggestPriceButtonVisible)
        return;
    return (_jsx(Box, { marginTop: "spacing.12", children: _jsx(Button, { testId: suggestPriceButtonTestId, variant: variant, icon: TagIcon, iconPosition: "start", isFullWidth: true, onPress: handlePress, isDisabled: isPreviewMode, children: t("contact.cta.suggest_price") }) }));
};
